import { Link, useNavigate } from "react-router-dom";
import { LogOut, Moon, Sun } from "lucide-react";
import { AuroraLogo } from "@/components/AuroraLogo";
import { useAuth, useTheme } from "@/context/AuthContext";
import { EncryptedBadge } from "@/components/EncryptedBadge";
import { SupportButton } from "@/components/SupportButton";
import { InstallAppButton } from "@/components/InstallAppButton";

export const TopBar = ({ mode = "user", children }) => {
  const { user, logout } = useAuth();
  const [theme, toggle] = useTheme();
  const nav = useNavigate();
  return (
    <header className="relative z-20 border-b border-border bg-background/70 backdrop-blur-xl" data-testid="top-bar">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center gap-4 px-4 sm:px-8">
        <Link to={mode === "admin" ? "/admin" : "/dashboard"} className="flex items-center gap-3" data-testid="nav-brand-logo">
          <AuroraLogo size={34} />
          <div className="hidden leading-tight sm:block">
            <div className="font-display text-sm font-extrabold tracking-tight">SPEECH<span className="text-[color:var(--au-green)]">FLOW</span> <span className="font-mono text-[9px] font-normal tracking-widest text-[color:var(--au-violet)]">· POWERED BY AURORA-ON</span></div>
            <div className="mono-label !text-[10px]">{mode === "admin" ? "SU // COMMAND HUD" : "LIVE TRANSLATION GRID"}</div>
          </div>
        </Link>
        <div className="flex-1">{children}</div>
        <EncryptedBadge />
        <span className="hidden items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-muted-foreground md:flex">
          <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--au-green)] shadow-[0_0_8px_var(--au-green)]" /> {user?.name}
        </span>
        <InstallAppButton />
        <SupportButton />
        <button onClick={toggle} className="icon-btn" data-testid="nav-theme-toggle" aria-label="Toggle theme">
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
        </button>
        <button onClick={async () => { await logout(); nav("/"); }} className="icon-btn" data-testid="nav-logout-button" aria-label="Logout">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
};
